import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
import helpers from 'src/styles/helpers';
const useStyles = makeStyles(_objectSpread(_objectSpread(_objectSpread({}, sections), helpers), {}, {
  modalScrollableContent: {
    maxHeight: '400px',
    overflow: 'auto',
    padding: '32px 40px'
  },
  termsConditionsLine: {
    '& .modal-trigger': {
      display: 'inline'
    },
    '& button': {
      padding: 0,
      border: 'none',
      fontSize: '18px',
      cursor: 'pointer',
      display: 'inline',
      background: 'transparent',
      color: palette.primary.dark,
      transition: "color ".concat(palette.transitions.short),
      '&:hover': {
        boxShadow: 'none',
        color: palette.primary.dark,
        backgroundColor: 'transparent'
      }
    }
  },
  errorAlert: {
    marginLeft: '-40px',
    marginRight: '-40px',
    marginTop: '-32px',
    marginBottom: '32px'
  },
  additionalInfo: {
    color: palette.shades[700],
    marginBottom: '48px',
    marginTop: '18px'
  },
  loaderWrapper: {
    marginTop: '180px',
    textAlign: 'center'
  }
}));
export default useStyles;